<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否支付押金" prop="hasPayDeposit">
            <a-radio-group v-model="form.hasPayDeposit">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.hasPayDeposit == 0">
          <a-form-model-item
            label="是押金交纳要求"
            prop="depositPayRequirement"
          >
            <a-input
              v-model="form.depositPayRequirement"
              placeholder="例：押一付一"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-model-item label="租金支付要求" prop="rentPaymenclaim">
            <a-radio-group v-model="form.rentPaymenclaim">
              <a-radio :value="1">按月</a-radio>
              <a-radio :value="2">按季度</a-radio>
              <a-radio :value="3">按年</a-radio>
              <a-radio :value="4">其他</a-radio>
            </a-radio-group>
            <a-form-model-item
                prop="rentPaymenclaimDesc"
                v-if="form.rentPaymenclaim === 4"
              >
                <a-textarea v-model="form.rentPaymenclaimDesc" :rows="1" />
              </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style>
</style>